/* eslint-disable import/prefer-default-export */
import { useState, useEffect } from 'react';

import { getCookie, setCookie } from '../utils/globalFunctions';

/**
 * @returns {{isFilterPinned: boolean, setIsFilterPinned: React.Dispatch<React.SetStateAction<boolean>>}}
 */
export const useFilterPinned = () => {
  const [isFilterPinned, setIsFilterPinned] = useState(null);

  useEffect(() => {
    const isFilterPinnedCookie = getCookie('isFilterPinned') === 'true';

    setIsFilterPinned(isFilterPinnedCookie);
  }, []);

  useEffect(() => {
    setCookie('isFilterPinned', isFilterPinned);
  }, [isFilterPinned]);

  return { isFilterPinned, setIsFilterPinned };
};
